import { FC } from 'react';
import { TreatmentGroup } from '@/model/TreatmentGroup.model.ts';
import { GroupListItem } from './GroupListItem';

interface GroupListProps {
  groups: Array<TreatmentGroup>;
  showControlChip?: boolean;
  maxHeight?: string;
}

export const ReadOnlyGroupList: FC<GroupListProps> = ({ groups, showControlChip = true, maxHeight = '300px' }) => {
  if (groups.length === 0) {
    return (
      <div className="tc pv4" data-test-component="GroupList" data-test-element="empty-state">
        <p className="f6 gray" data-testid="empty-message">
          No groups available
        </p>
      </div>
    );
  }

  return (
    <div
      className={`ml3 pv2 flex flex-column overflow-y-auto`}
      style={{ maxHeight }}
      data-test-component="GroupList"
      data-test-element="container"
    >
      {groups.map((group) => (
        <GroupListItem
          key={group.api_id ?? group.temp_id ?? group.id}
          group={group}
          showControlChip={showControlChip}
        />
      ))}
    </div>
  );
};
